export default function getCircleRadians(radians: number[], isbtw: boolean) {
  const r = [...radians];
  return isbtw ? r : [r[2], r[1], r[0]];
}